import { Avatar, Dropdown } from "antd";
import { Button, Divider, Icon, Text, Title } from "components/common";
import theme from "utils/themeVars";
import styles from "./userMenu.module.less";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "store/appSlice";
import parentApi from "store/parentApi";
import { useNavigate } from "react-router-dom";
import { getUserProfilePath, LOGIN_PATH } from "constants/app-paths";

const UserMenu = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.app.user?.info);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("presentation_url");
    navigate(LOGIN_PATH);
    dispatch(logout());
    dispatch(parentApi.util.resetApiState());
  };
  const items = [
    {
      label: "My Profile",
      key: "profile",
      icon: <Icon icon="FiUser" style={{ color: "#4b93ff" }} />,
      onClick: () => user?.user_code && navigate(getUserProfilePath(user.user_code)),
    },
    {
      label: "Logout",
      key: "1",
      icon: <Icon icon="FiLogOut" style={{ color: "#4b93ff" }} />,
      onClick: handleLogout,
    },
  ];

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Dropdown
          menu={{ items }}
          dropdownRender={(menu) => (
            <div className={styles.userMenuOuter}>
              <div className={styles.userMenuHeader}>
                <div className={styles.userAvatar}>
                  <Avatar 
                    size={54} 
                    src={user?.profile_image}
                    icon={!user?.profile_image ? <Icon icon={"FiUser"} size={30} style={{ color: "#4b93ff" }} /> : null}
                    style={{ backgroundColor: !user?.profile_image ? "#f3fbff" : "transparent" }}
                  />
                </div>
                <div className={styles.userInfo}>
                  <Title level={5} style={{ marginBottom: "10px" }}>
                    {user?.firstname} {user?.lastname}
                  </Title>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      marginBottom: "5px",
                    }}
                  >
                    <Icon icon={"HiOutlineMail"} size={17} style={{ color: "#4b93ff" }} />
                    <Text>{user?.email}</Text>
                  </div>

                  <div className={styles.userDesignation}>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginBottom: "5px",
                      }}
                    >
                      <Icon icon={"MdSmartphone"} size={17} style={{ color: "#4b93ff" }} />
                      <Text>+{user?.phone_number}</Text>
                    </div>
                  </div>
                </div>
              </div>
              <Divider style={{ marginBlock: "1rem" }} />
              <div className="fs16">{menu}</div>
            </div>
          )}
          className="d-grid"
        >
          <div>
            <Button
              icon={
                user?.profile_image ? (
                  <Avatar size={34} src={user?.profile_image} />
                ) : (
                  "UserIcon"
                )
              }
              iconProps={{ size: "16px" }}
              bordered
              shape="circle"
              style={{ border: "1px solid #c5c6d0" }}
            />
          </div>
        </Dropdown>
      </div>
    </>
  );
};

export default UserMenu;
